export const DISABLE_VOTES = 'spec.wixReviews.DisableVotes';
